import { taskManagementRoutes } from './taskManagementRoutes';

const base = taskManagementRoutes.recognitions;

export const recognitionRoutes = {
  base,
  create: `${base}/create`,
  recognitionId: (id: string) => `${base}/${id}` as const,
  notFound: `${base}/recognition-not-found`,
} as const;
